import './index.css'

import { applyMiddleware, compose, createStore } from 'redux'
import { keycloak, keycloakProviderInitConfig, onKeycloakEvent, setKeycloakToken } from './keycloak'
import { persistReducer, persistStore } from 'redux-persist'

import App from './App'
import { KeycloakProvider } from '@react-keycloak/web'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import React from 'react'
import logger from 'redux-logger'
import promise from 'redux-promise-middleware'
import reducer from './reducers'
import { render } from 'react-dom'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

const middleware = [thunk]

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleware, logger, promise(), thunk)))

const persistor = persistStore(store)

render(
  <KeycloakProvider
    keycloak={keycloak}
    onTokens={setKeycloakToken}
    initConfig={keycloakProviderInitConfig}
    LoadingComponent={<a>Waiting For Keycloak</a>}
    onEvent={onKeycloakEvent}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App keycloak={keycloak} />
      </PersistGate>
    </Provider>
  </KeycloakProvider>,

  document.getElementById('root')
)
